/**
 * Formally FavoriteDealer.js by Vincent Y
 *
 * Renamed and modified by liliana
 */

'use strict';

var $ = require('dibs-jquery-shim');
var Backbone = require('dibs-backbone');
var template = require('../../../../templates/favorites/main');
var tokenReplace = require('dibs-token-replace');
var tracking = require('dibs-tracking');
var SV = require('server-vars');
var copyText = require('bunsen/helpers/copyText')();

var React = require('react');
var ReactDOM = require('react-dom');
var favoriteCtaConnectToStoresHelper = require('../../../../components/FavoriteCta/connectToStoresHelper');
var FavoriteButton = require('../../../../components/FavoriteCta/FavoriteButton');
var FAVORITE_TRACKING = require('../../../../components/FavoriteCta/trackingData');
var favoriteCtaCopy = SV.get('favoriteCta.messageCenter.cta');
var FavoriteModel = require('bunsen/models/identity/Favorite');
var TYPE_DEALER = FavoriteModel.TYPE_DEALER;

var FavoriteButtonConnected = favoriteCtaConnectToStoresHelper({
    component: FavoriteButton,
    type: TYPE_DEALER
});
var FavoriteDealerView;

require('../../../../contact/dealer/styles/favorite-dealer.scss');

FavoriteDealerView = module.exports = Backbone.BaseView.extend({
    model: new Backbone.AssociatedModel(),

    template: template.favoriteContactedDealer,

    className: 'email-success-wrapper',

    timeOut: 3000,

    events: {
        'mouseover': 'modalMouseOver',
        'mouseout': 'modalMouseOut',
        'click .no-thanks': function (e) {
            e.preventDefault();
            this._closeModal();
        },
        'click .bomtLink': function () {
            tracking.trackEvent(this._omtLinkParams);
        }
    },

    initialize: function (options) {
        options = options || {};
        this._dealerUrl = options.dealerUrl || SV.get('modalData.dealerUrl');
        this._dealerPk = options.dealerPk || SV.get('modalData.dealerPk');
        this._dealerName = options.dealerName || SV.get('modalData.dealerName');
        this._copyText = options.copyText || copyText.extend(SV.get('modalData.copy'));
        this._closeModal = options.closeModal || this.closeModal;
        this._openModal = options.openModal;
        this._followDealerParams = options.followDealerParams;
        this._omtLinkParams = options.omtLinkParams;
        this._offerSent = options.offerSent;
        this._holdRequestSent = options.holdRequestSent;
        this._componentContext = options.componentContext;
        this._isSaved = options.isSaved;
        this._isArtSeller = options.isArtSeller;
    },

    render: function () {
        FavoriteDealerView.__super__.render.apply(this, arguments);
        if (!this._isSaved) {
            ReactDOM.render(
                React.createElement(
                    'div',
                    {className: 'favorite-dealer-cta-wrapper is-hidden'},
                    React.createElement(FavoriteButtonConnected, {
                        context: this._componentContext,
                        className: 'button-medium button-primary favorite-dealer-cta add-favorite',
                        cta: favoriteCtaCopy,
                        favoriteData: {
                            type: TYPE_DEALER,
                            page: this._dealerUrl,
                            primaryKey: this._dealerPk
                        },
                        tracking: FAVORITE_TRACKING.DEALER.CONTACT_MODAL,
                        onClick: this._closeModal
                    })
                ), this.$('.favorite-dealer-cta-container')[0]
            );
        }

        this.$('.favorite-dealer-cta-wrapper, .favorite-dealer-info').removeClass('is-hidden');
        this.timeOut = 10000;

        this.model.set('showingFavDealerCtas', !this._isSaved);
        this.setModalTimeout(this.timeOut);
        this._openModal();
        return this;
    },
    templateVars: function () {
        var successMsg;
        var successSubtext = this._copyText.get('successInfoSubtext');
        if (this._holdRequestSent) {
            successMsg = this._copyText.get(this._isNetPrice ?
                'successMessageNetPriceHold' : 'successMessageHold');
        } else {
            successMsg = this._copyText.get(this._offerSent ?
                'successMessageOffer' : 'successMessage');
        }
        return {
            successMessage: tokenReplace(successMsg, {
                dealerName: this._dealerName
            }),
            successInfoSubtext: tokenReplace(successSubtext, {
                dealerType: this._isArtSeller ? 'gallery' : 'dealer'
            }),
            copy: this._copyText.get.bind(this._copyText)
        };
    },

    closeModal: function () {
        $.publish('modal:close');
    },

    setModalTimeout: function (interval) {
        this.modalTimeout = setTimeout(this._closeModal, interval || 5000);
    },

    modalMouseOver: function () {
        clearTimeout(this.modalTimeout);
    },

    modalMouseOut: function () {
        clearTimeout(this.modalTimeout);
        this.setModalTimeout();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/views/FavoriteDealerView.js
// module id = 829
// module chunks = 4 6 8 9 17